// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminal-wrapper {
  border-radius: 7px;
  background-color: #fff;
  box-shadow:
    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  /* margin-top: 4rem;
  margin-left: 14px; */
  padding: 10px;
  cursor: pointer;
  line-height: 2;
  height: fit-content;
  width: max-content;
}

@media (max-width: 576px) {
  .terminal-wrapper {
    margin-left: 0;
  }
}

.dark .terminal-wrapper {
  background-color: #353a50;
}

.terminal-wrapper-I {
  width: 350px;
  border-radius: 7px;
  background-color: #fff;
  box-shadow:
    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  margin-top: 5px;
  margin-left: 14px;
  padding: 10px;
  cursor: pointer;
  line-height: 2;
}

.icons-wrapper-flex {
  display: flex;
  align-items: center;
  gap: 10px;
}

.varient-text {
  text-align: center !important;
  margin-bottom: 5px !important;
  text-transform: capitalize !important;
}

.active-icons-ons {
  color: green !important;
}

.credit-off-icons {
  color: red !important;
}

.payment-mode-card-par {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 1rem;
  padding: 1rem;
  color: var(--surface-g5);
  align-items: center;
  border: 1px solid var(--surface-g0);
  border-radius: 10px;
  background-color: var(--surface-g0);
}

.payment-mode-card-par-active {
  border-color: #0860e6;
  background-color: #fff;
}

.dark .payment-mode-card-par {
  color: #fff;
  background-color: #5e5f69;
}

.payment-mode-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.dark .payment-mode-card-header {
  color: #fff !important;
}

.dark .payment-mode-card-header svg {
  color: #fff !important;
}

.payment-card-img-div {
  width: auto;
  height: 100%;
  object-fit: cover;
}

.payment-mode-card-img-par {
  height: 200px;
  overflow: hidden;
}

.container {
  margin-top: 70px;
  width: 100%;
}

.pt-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  background-color: rgba(248, 250, 252, 0.9);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  transition: background-color 0.3s ease, border-color 0.3s ease;
  margin-bottom: 1rem;
}

.dark .pt-sticky-header {
  border-bottom: 1px solid rgba(51, 65, 85, 0.7);
  background-color: rgba(15, 23, 42, 0.9);
}

.pt-header-content {
  display: flex;
  height: 4rem;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
}

.pt-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.pt-header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dark .pt-header-title {
  color: #f8fafc;
}

.payment-modes-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 0px 15px 0px 15px;
}

.screen-mode-btn-par {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.screen-mode-btn-par button {
  position: relative;
  margin-right: 0 !important;
}

.payment-mode-subtext {
  font-size: 0.8rem;
}

.payment-mode-active-clr {
  color: #0b742c;
}

.dark .payment-mode-active-clr {
  color: #fff;
}

.payment-mode-active-clr-offline {
  color: #e90000;
}

.dark .payment-mode-active-clr-offline {
  color: #fff;
}

.btn-save-cancel-wrapper-box {
  display: grid;
  grid-template-columns: 1fr 3fr;
  width: 100%;
}

/* ─────────────────────────────────────────────
   Payment Config Manager Modal
───────────────────────────────────────────── */

.menu_payment_config_manager_modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

.menu_payment_config_manager_modal-card {
  position: relative;
  width: 100%;
  max-width: 400px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
  background: #fff;
}

.menu_payment_config_manager_modal-close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.2s;
}
.menu_payment_config_manager_modal-close-btn:hover {
  color: #fff;
}

.menu_payment_config_manager_modal-header {
  background-color: #0f172a;
  padding: 28px 24px 24px;
  text-align: center;
}

.menu_payment_config_manager_modal-lock-icon {
  width: 64px;
  height: 64px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.menu_payment_config_manager_modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px;
}

.menu_payment_config_manager_modal-subtitle {
  font-size: 0.8125rem;
  color: #94a3b8;
  margin: 0;
}

.menu_payment_config_manager_modal-body {
  background: #fff;
  padding: 24px 24px 28px;
}

.menu_payment_config_manager_modal-field-group {
  margin-bottom: 18px;
}

.menu_payment_config_manager_modal-label {
  display: block;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 8px;
}

.menu_payment_config_manager_modal-pin-wrapper .MuiInput-root,
.menu_payment_config_manager_modal-pin-wrapper .numberInput1 {
  width: 100%;
  height: 56px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px !important;
  padding: 0 14px;
  font-weight: 700;
  letter-spacing: 0.45em;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: none;
}

.menu_payment_config_manager_modal-pin-wrapper .MuiInput-root:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.menu_payment_config_manager_modal-verify-btn {
  width: 100% !important;
  height: 48px !important;
  background: #2563eb !important;
  color: #fff !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  border-radius: 12px !important;
  border: none !important;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3) !important;
  transition: background 0.2s, box-shadow 0.2s, opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
.menu_payment_config_manager_modal-verify-btn:hover:not(:disabled) {
  background: #1d4ed8 !important;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.38) !important;
}
.menu_payment_config_manager_modal-verify-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.menu_payment_config_manager_modal-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
}
.menu_payment_config_manager_modal-actions--center {
  justify-content: center;
  margin-top: 14px;
}

.menu_payment_config_manager_modal-cancel-btn {
  background: transparent;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
}
.menu_payment_config_manager_modal-cancel-btn:hover {
  background: #f1f5f9;
  color: #334155;
}

@media (max-width: 480px) {
  .menu_payment_config_manager_modal-card {
    max-width: 100%;
    border-radius: 0;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .menu_payment_config_manager_modal-body {
    flex: 1;
  }
}

/* ── Dark mode ── */
.dark .terminal-wrapper-I {
  background-color: #353a50;
}

.dark .payment-mode-card-par-active {
  background-color: #1e293b;
  border-color: #2563eb;
}

.dark .menu_payment_config_manager_modal-card {
  background: #1e293b;
}

.dark .menu_payment_config_manager_modal-body {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .menu_payment_config_manager_modal-label {
  color: #94a3b8;
}

.dark .menu_payment_config_manager_modal-pin-wrapper .MuiInput-root,
.dark .menu_payment_config_manager_modal-pin-wrapper .numberInput1 {
  background: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .menu_payment_config_manager_modal-cancel-btn {
  color: #94a3b8;
}

.dark .menu_payment_config_manager_modal-cancel-btn:hover {
  background: #334155;
  color: #f1f5f9;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/paymentTerminal/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;;0CAEwC;EACxC;sBACoB;EACpB,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB;;0CAEwC;EACxC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;+CAE+C;;AAE/C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,wDAAwD;EACxD,0DAA0D;EAC1D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,OAAO;EACT;AACF;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".terminal-wrapper {\n  border-radius: 7px;\n  background-color: #fff;\n  box-shadow:\n    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  /* margin-top: 4rem;\n  margin-left: 14px; */\n  padding: 10px;\n  cursor: pointer;\n  line-height: 2;\n  height: fit-content;\n  width: max-content;\n}\n\n@media (max-width: 576px) {\n  .terminal-wrapper {\n    margin-left: 0;\n  }\n}\n\n.dark .terminal-wrapper {\n  background-color: #353a50;\n}\n\n.terminal-wrapper-I {\n  width: 350px;\n  border-radius: 7px;\n  background-color: #fff;\n  box-shadow:\n    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  margin-top: 5px;\n  margin-left: 14px;\n  padding: 10px;\n  cursor: pointer;\n  line-height: 2;\n}\n\n.icons-wrapper-flex {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.varient-text {\n  text-align: center !important;\n  margin-bottom: 5px !important;\n  text-transform: capitalize !important;\n}\n\n.active-icons-ons {\n  color: green !important;\n}\n\n.credit-off-icons {\n  color: red !important;\n}\n\n.payment-mode-card-par {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 1rem;\n  padding: 1rem;\n  color: var(--surface-g5);\n  align-items: center;\n  border: 1px solid var(--surface-g0);\n  border-radius: 10px;\n  background-color: var(--surface-g0);\n}\n\n.payment-mode-card-par-active {\n  border-color: #0860e6;\n  background-color: #fff;\n}\n\n.dark .payment-mode-card-par {\n  color: #fff;\n  background-color: #5e5f69;\n}\n\n.payment-mode-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.dark .payment-mode-card-header {\n  color: #fff !important;\n}\n\n.dark .payment-mode-card-header svg {\n  color: #fff !important;\n}\n\n.payment-card-img-div {\n  width: auto;\n  height: 100%;\n  object-fit: cover;\n}\n\n.payment-mode-card-img-par {\n  height: 200px;\n  overflow: hidden;\n}\n\n.container {\n  margin-top: 70px;\n  width: 100%;\n}\n\n.pt-sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7);\n  background-color: rgba(248, 250, 252, 0.9);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n  margin-bottom: 1rem;\n}\n\n.dark .pt-sticky-header {\n  border-bottom: 1px solid rgba(51, 65, 85, 0.7);\n  background-color: rgba(15, 23, 42, 0.9);\n}\n\n.pt-header-content {\n  display: flex;\n  height: 4rem;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  box-sizing: border-box;\n}\n\n.pt-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.pt-header-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .pt-header-title {\n  color: #f8fafc;\n}\n\n.payment-modes-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  padding: 0px 15px 0px 15px;\n}\n\n.screen-mode-btn-par {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.screen-mode-btn-par button {\n  position: relative;\n  margin-right: 0 !important;\n}\n\n.payment-mode-subtext {\n  font-size: 0.8rem;\n}\n\n.payment-mode-active-clr {\n  color: #0b742c;\n}\n\n.dark .payment-mode-active-clr {\n  color: #fff;\n}\n\n.payment-mode-active-clr-offline {\n  color: #e90000;\n}\n\n.dark .payment-mode-active-clr-offline {\n  color: #fff;\n}\n\n.btn-save-cancel-wrapper-box {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  width: 100%;\n}\n\n/* ─────────────────────────────────────────────\n   Payment Config Manager Modal\n───────────────────────────────────────────── */\n\n.menu_payment_config_manager_modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.menu_payment_config_manager_modal-card {\n  position: relative;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);\n  background: #fff;\n}\n\n.menu_payment_config_manager_modal-close-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 10;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 6px;\n  transition: color 0.2s;\n}\n.menu_payment_config_manager_modal-close-btn:hover {\n  color: #fff;\n}\n\n.menu_payment_config_manager_modal-header {\n  background-color: #0f172a;\n  padding: 28px 24px 24px;\n  text-align: center;\n}\n\n.menu_payment_config_manager_modal-lock-icon {\n  width: 64px;\n  height: 64px;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.menu_payment_config_manager_modal-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 6px;\n}\n\n.menu_payment_config_manager_modal-subtitle {\n  font-size: 0.8125rem;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.menu_payment_config_manager_modal-body {\n  background: #fff;\n  padding: 24px 24px 28px;\n}\n\n.menu_payment_config_manager_modal-field-group {\n  margin-bottom: 18px;\n}\n\n.menu_payment_config_manager_modal-label {\n  display: block;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  margin-bottom: 8px;\n}\n\n.menu_payment_config_manager_modal-pin-wrapper .MuiInput-root,\n.menu_payment_config_manager_modal-pin-wrapper .numberInput1 {\n  width: 100%;\n  height: 56px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px !important;\n  padding: 0 14px;\n  font-weight: 700;\n  letter-spacing: 0.45em;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-shadow: none;\n}\n\n.menu_payment_config_manager_modal-pin-wrapper .MuiInput-root:focus-within {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.menu_payment_config_manager_modal-verify-btn {\n  width: 100% !important;\n  height: 48px !important;\n  background: #2563eb !important;\n  color: #fff !important;\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  border-radius: 12px !important;\n  border: none !important;\n  cursor: pointer;\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3) !important;\n  transition: background 0.2s, box-shadow 0.2s, opacity 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 4px;\n}\n.menu_payment_config_manager_modal-verify-btn:hover:not(:disabled) {\n  background: #1d4ed8 !important;\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.38) !important;\n}\n.menu_payment_config_manager_modal-verify-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.menu_payment_config_manager_modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin-top: 18px;\n}\n.menu_payment_config_manager_modal-actions--center {\n  justify-content: center;\n  margin-top: 14px;\n}\n\n.menu_payment_config_manager_modal-cancel-btn {\n  background: transparent;\n  color: #64748b;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: background 0.2s, color 0.2s;\n}\n.menu_payment_config_manager_modal-cancel-btn:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n@media (max-width: 480px) {\n  .menu_payment_config_manager_modal-card {\n    max-width: 100%;\n    border-radius: 0;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n  }\n  .menu_payment_config_manager_modal-body {\n    flex: 1;\n  }\n}\n\n/* ── Dark mode ── */\n.dark .terminal-wrapper-I {\n  background-color: #353a50;\n}\n\n.dark .payment-mode-card-par-active {\n  background-color: #1e293b;\n  border-color: #2563eb;\n}\n\n.dark .menu_payment_config_manager_modal-card {\n  background: #1e293b;\n}\n\n.dark .menu_payment_config_manager_modal-body {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .menu_payment_config_manager_modal-label {\n  color: #94a3b8;\n}\n\n.dark .menu_payment_config_manager_modal-pin-wrapper .MuiInput-root,\n.dark .menu_payment_config_manager_modal-pin-wrapper .numberInput1 {\n  background: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .menu_payment_config_manager_modal-cancel-btn {\n  color: #94a3b8;\n}\n\n.dark .menu_payment_config_manager_modal-cancel-btn:hover {\n  background: #334155;\n  color: #f1f5f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
